import React, { useMemo, useState, useEffect } from "react";
import "./PayrollDetail.css";
import { GrNotification } from "react-icons/gr";
import { IoIosArrowBack } from "react-icons/io";
import Header from "../../components/common/Header";


const PayrollDetail = ({ row, onClose }) => {
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    token: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "GUEST";
    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
    });
  }, []);
  // Basic editable state; in future can be replaced by form library
// PayrollDetail.js kulla form state-ai ippadi update pannunga
const [form, setForm] = useState({
  employeeName: row?.employeeName || "",
  jobRole: row?.jobRole || "",
  salary: row?.grossSalary || "", // row.salary-ku bathila grossSalary
  band: row?.band || "",
  mobile: row?.mobileNumber || "", // API-la mobileNumber nu iruku
  shift: row?.shift || "",
  paidDays: row?.paidDays || 0,
  lopDays: row?.lopDays || 0,
  month: row?.payMonth || "",
  basic: row?.basicSalary || "",
  hra: row?.hra || "",
  conveyance: row?.conveyance || "",
  dearness: row?.dearness || "",
  attendanceBonus: row?.attendanceBonus || "",
  otherAllowance: row?.otherAllowance || "",
  epf: row?.epf || "",
  esi: row?.esi || "",
  otherDeduction: row?.totalDeduction || "", // Deduction total-ai inge vachukalaam
  overtime: row?.overTime || "",
  overtimePercent: row?.overTimePercent || "",
  netSalary: row?.netSalary || 0, // Intha field-ai extra-va add pannikonga
});

  const toNum = (v) => (v === undefined || v === null || v === "" ? 0 : Number(v) || 0);

  const overtimeAmount = useMemo(() => {
    const salaryNum = toNum(form.salary);
    if (form.overtime !== "") return toNum(form.overtime);
    if (form.overtimePercent !== "") return (salaryNum * toNum(form.overtimePercent)) / 100;
    return 0;
  }, [form.salary, form.overtime, form.overtimePercent]);

  const allowancesTotal = useMemo(() => {
    return (
      toNum(form.basic) +
      toNum(form.hra) +
      toNum(form.conveyance) +
      toNum(form.dearness) +
      toNum(form.attendanceBonus) +
      toNum(form.otherAllowance) +
      overtimeAmount
    );
  }, [form.basic, form.hra, form.conveyance, form.dearness, form.attendanceBonus, form.otherAllowance, overtimeAmount]);

  const deductionsTotal = useMemo(() => {
    return toNum(form.epf) + toNum(form.esi) + toNum(form.otherDeduction);
  }, [form.epf, form.esi, form.otherDeduction]);

  const grossSalary = allowancesTotal;
  const netSalary = useMemo(() => grossSalary - deductionsTotal, [grossSalary, deductionsTotal]);

  const allowancePercent = useMemo(() => {
    const salaryNum = toNum(form.salary);
    if (salaryNum <= 0) return 0;
    return (allowancesTotal / salaryNum) * 100;
  }, [form.salary, allowancesTotal]);

  const netPay = useMemo(() => netSalary, [netSalary]);

  const handleChange = (key) => (e) => {
    setForm((p) => ({ ...p, [key]: e.target.value }));
  };

  const fmt = (n) => {
    const num = Number(n);
    if (!isFinite(num)) return "0.00";
    return num.toFixed(2);
  };

  return (
    <>
      <Header
        showBack={true}
        onBack={onClose}
        title="Pay Roll"
        subtitle="Pay Roll Information"
      />

      <div className="table-container">
        <div className="detail-scroll">
          <div className="detail-body">
        <div className="form-area">
            <section className="section">
              <div className="section-title">Employee Details</div>
              <div className="grid two-col">
                <div className="field">
                  <label>Employee Name</label>
                  <input value={form.employeeName} onChange={handleChange("employeeName")} />
                </div>
                <div className="field">
                  <label>Shift</label>
                  <input value={form.shift} onChange={handleChange("shift")} />
                </div>
                <div className="field">
                  <label>Employee Code</label>
                  <input value={row?.id || ""} readOnly />
                </div>
                <div className="field">
                  <label>Paid Days</label>
                  <input value={form.paidDays} onChange={handleChange("paidDays")} />
                </div>
                <div className="field">
                  <label>Mobile Number</label>
                  <input value={form.mobile} onChange={handleChange("mobile")} />
                </div>
                <div className="field">
                  <label>LOP Days</label>
                  <input value={form.lopDays} onChange={handleChange("lopDays")} />
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-title">Salary Details</div>
              <div className="grid three-col">
                <div className="field">
                  <label>Job Role</label>
                  <input value={form.jobRole} onChange={handleChange("jobRole")} />
                </div>
                <div className="field">
                  <label>Salary</label>
                  <input value={form.salary} onChange={handleChange("salary")} />
                </div>
                <div className="field">
                  <label>Band</label>
                  <input value={form.band} onChange={handleChange("band")} />
                </div>
              </div>
            </section>

            <div className="columns">
              <section className="section half">
                <div className="section-title">Allowance's</div>
                <div className="grid two-col">
                  <div className="field"><label>Basic Salary</label><input value={form.basic} onChange={handleChange("basic")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>HRA</label><input value={form.hra} onChange={handleChange("hra")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>Conveyance</label><input value={form.conveyance} onChange={handleChange("conveyance")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>Dearness</label><input value={form.dearness} onChange={handleChange("dearness")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>Attendance Bonus</label><input value={form.attendanceBonus} onChange={handleChange("attendanceBonus")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>Others</label><input value={form.otherAllowance} onChange={handleChange("otherAllowance")} /></div>
                  <div className="field"><label>%</label><input/></div>
                </div>
              </section>

              <section className="section half">
                <div className="section-title">Deductions</div>
                <div className="grid two-col">
                  <div className="field"><label>EPF</label><input value={form.epf} onChange={handleChange("epf")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>ESI</label><input value={form.esi} onChange={handleChange("esi")} /></div>
                  <div className="field"><label>%</label><input/></div>
                  <div className="field"><label>Other</label><input value={form.otherDeduction} onChange={handleChange("otherDeduction")} /></div>
                  <div className="field"><label>%</label><input/></div>
                </div>
              </section>
            </div>

            <section className="section">
              <div className="section-title">Total</div>
              <div className="grid three-col">
                <div className="field"><label>Gross Salary</label><input value={fmt(grossSalary)} readOnly /></div>
                <div className="field"><label>Net Salary</label><input value={fmt(netSalary)} readOnly /></div>
                <div className="field"><label>Total Deduction</label><input value={fmt(deductionsTotal)} readOnly /></div>
              </div>
              <div className="grid two-col">
                <div className="field"><label>Over Time</label><input value={form.overtime} onChange={handleChange("overtime")} /></div>
                <div className="field"><label>%</label><input value={form.overtimePercent} onChange={handleChange("overtimePercent")}/></div>
              </div>
              <div className="grid two-col">
                <div className="field"><label>Total</label><input value={fmt(allowancesTotal)} readOnly /></div>
                <div className="field"><label>%</label><input value={fmt(allowancePercent)} readOnly /></div>
              </div>
            </section>
        </div>

        <aside className="side-card">
  <div className="card-title">Net Payable</div>
  {/* ₹ 0000 nu dummy text illama real data-va fmt panni kaatalaam */}
  <div className="card-amount">
    ₹ {row?.netSalary ? row.netSalary.toLocaleString('en-IN', { minimumFractionDigits: 2 }) : "0.00"}
  </div>
</aside>
          </div>
        </div>

        {/* <div className="detail-footer">
          <button className="btn ghost" onClick={onClose}>Cancel</button>
          <button className="btn primary">Save</button>
        </div> */}
      </div>
    </>
  );
};

export default PayrollDetail;
